import ContentBox from 'components/ContentBox'
import { COUNTRY_CURRENCY } from 'modules/country/constants/currency'
import PropTypes from 'prop-types'
import React from 'react'
import Link from 'components/Link'
import OrderRowBody from './OrderRow.Body'
import OrderRowHeader from './OrderRow.Header'

class OrderRow extends React.Component {
  renderBody () {
    const elem = (
      <OrderRowBody
        order={this.props.value}
        promoCodes={this.props.promoCodes}
        url={this.props.url}
      />
    )
    if (!this.props.url) {
      return elem
    }
    return (
      <Link to={this.props.url}>
        {elem}
      </Link>
    )
  }

  renderHeader () {
    return (
      <OrderRowHeader
        currency={this.props.currency}
        discount={this.props.discount}
        order={this.props.value}
        promoCodes={this.props.promoCodes}
        shipping={this.props.shipping}
        subTotal={this.props.subTotal}
        total={this.props.total}
      />
    )
  }

  render () {
    return (
      <ContentBox px={0}>
        {this.renderHeader()}
        {this.renderBody()}
      </ContentBox>
    )
  }
}

OrderRow.propTypes = {
  value: PropTypes.object,
  promoCodes: PropTypes.arrayOf(
    PropTypes.object
  ),
  url: PropTypes.string,
  subTotal: PropTypes.number.isRequired,
  discount: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  shipping: PropTypes.number.isRequired,
  currency: PropTypes.oneOf(Object.values(COUNTRY_CURRENCY)).isRequired
}
export default OrderRow
